import { render, staticRenderFns } from "./PendingLinksTab.vue?vue&type=template&id=04f1c885&scoped=true"
import script from "./PendingLinksTab.vue?vue&type=script&lang=js"
export * from "./PendingLinksTab.vue?vue&type=script&lang=js"
import style0 from "./PendingLinksTab.vue?vue&type=style&index=0&id=04f1c885&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f1c885",
  null
  
)

export default component.exports